import React, { Fragment } from "react"
import * as dateHelper from "../../helpers/date"
import config from "react-global-configuration"
import { getCssLegend } from "../../helpers/bookingHelper"
import useWindowWidth from "../../../hooks/useWindowWidth"

export default function CheckoutCompareBookings(props) {
  const windowWidth = useWindowWidth()

  const getDate = (date) => {
    const day = dateHelper.formatDate(date, "dddd")
    const formattedDay = day.charAt(0).toUpperCase() + day.slice(1)
    const formattedDate = dateHelper.formatDate(date, "DD/MM/YYYY")
    return `${formattedDay} ${formattedDate}`
  }

  if (!props.changeFromBooking) return null

  const { booking: cfBooking, carPark: cfCarPark, product: cfProduct, parking: cfParking } = props.changeFromBooking
  const { booking, carPark, product, parking, modificationSummary } = props.bookingResult
  const isParkingUpgrade = true || parking.isParkingUpgrade
  const textKeys = config.get("textKeys.checkout.compare") || {}
  const allKeys = config.get("textKeys.checkout") || {}

  const newLegend = getCssLegend(props.bookingResult.carPark.name, props.bookingResult.carPark.name)
  const oldLegend = getCssLegend(props.changeFromBooking.carPark.name, props.changeFromBooking.carPark.name)

  const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText
  const cfThirdPartyPromoLabel = cfBooking?.thirdPartyPromoLabelText

  let changeFromMembership = cfBooking?.membershipNumber ? true : false
  let loggedInMembership = props.userAccountDetails?.CustomerNumber ? true : false
  let hasLoggedInInfo = loggedInMembership || changeFromMembership ? true : false

  let membershipCarParks = [77, 71]
  const changeFromBookingPrice = cfBooking.items.parkings[0].amount
  let bookingResultPrice
  if (parking?.memberPrice) {
    bookingResultPrice = parking.amount
    if (booking.promotionCode && booking.promotionSaving > 0) {
      bookingResultPrice = parking.originalAmount
    } else if (!!booking.affiliateCode && !booking.useMemberPrice && parking.amount < parking.originalAmount) {
      bookingResultPrice = parking.amount
    } else if (membershipCarParks.includes(carPark?.id) && hasLoggedInInfo && booking?.useMemberPrice && parking?.memberPrice?.totalPrice) {
      bookingResultPrice = parking?.memberPrice?.totalPrice
    } else if (parking.isParkingUpgrade) {
      bookingResultPrice = parking.amount
    }
  } else {
    bookingResultPrice = parking.originalAmount ?? parking.amount // fallback to amount if originalAmount is null
    if (booking.promotionCode && booking.promotionSaving > 0) {
      bookingResultPrice = parking.originalAmount
    } else if (!!booking.affiliateCode && !booking.useMemberPrice && parking.amount < parking.originalAmount) {
      bookingResultPrice = parking.amount
    } else if (membershipCarParks.includes(carPark?.id) && hasLoggedInInfo && booking?.useMemberPrice) {
      bookingResultPrice = parking.amount
    } else if (parking.isParkingUpgrade || cfParking.isParkingUpgrade) {
      // if current or previous booking was an upgrade
      bookingResultPrice = parking.amount
    }
  }

  //promotion discount
  const bookingHasPromotionDiscount =
    !!props.bookingResult?.booking?.promotionCode && props.bookingResult?.booking?.promotionSaving > 0 ? true : false
  let bookingPromotionDiscountValue = 0
  //let promotionDiscountText = textKeys.promotionDiscount || "Totalbesparelse for denne ordre: {price} DKK"

  if (bookingHasPromotionDiscount) {
    bookingPromotionDiscountValue = props.bookingResult?.booking?.promotionSaving
    bookingResultPrice = parking?.amount
  }

  //cph profile discount
  const hasActiveMembershipPrice = membershipCarParks.includes(carPark?.id) && hasLoggedInInfo
  let membershipBookingPriceDifference = 0
  //let membershipDiscountText = textKeys.membershipDiscount || "Totalbesparelse for denne ordre: {price} DKK"

  if (hasActiveMembershipPrice)
    if (parking?.memberPrice && parking?.standardPrice) {
      membershipBookingPriceDifference = parking?.memberPrice?.totalPrice - parking?.standardPrice?.totalPrice || parking.standardPrice?.totalPrice
    } else {
      membershipBookingPriceDifference = parking?.amount - parking?.originalAmount
    }

  return (
    <div className="form__section form__section--no-border">
      <section className="checkout-content">
        <section className="section-body first">
          <header className="amend-booking-header">
            <h1>
              <strong>{textKeys.currentBooking || "Ny booking"}</strong>
            </h1>
          </header>
          <div className="drive-in">
            <p className="left">
              <strong>{textKeys.driveInDate || "Indkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(booking.arrivalDate)} ({booking.arrivalTime})
            </p>
          </div>

          <div className="drive-out">
            <p className="left">
              <strong>{textKeys.driveOutDate || "Udkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(booking.departureDate)} ({booking.departureTime})
            </p>
          </div>
          <hr />

          {/* <span className={`parking-legend__item parking-legend__item--${newLegend}`}>
                            {carPark.name}
                        </span> */}

          <div className={`parking-info ${thirdPartyPromoLabel ? "shows-promo-label" : ""}`}>
            <div className={`parking-product-table__list__col parking-product-table__list__col--title`}>
              <div className="parking-legend__current parking-legend--list">
                <span className={`parking-legend__item parking-legend__item--${newLegend}`}>{carPark.name}</span>
              </div>
              {windowWidth > 450 ? (
                <h5>{`${product.name}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}`}</h5>
              ) : (
                <h5>
                  {product.name}
                  <br></br>
                  {thirdPartyPromoLabel ? thirdPartyPromoLabel : ""}
                </h5>
              )}
            </div>
            <p className="right">{props.priceFormatter(bookingResultPrice)}</p>
          </div>
          {/* <a className="direction" href="https://www.cph.dk/parkering-transport/parkeringskort">{textKeys.findWayText || "Find vej til"} {carPark.name}</a> */}
        </section>

        <section className="section-body last">
          <header className="amend-booking-header">
            <h1>
              <strong>{textKeys.previousBooking || "Tidligere booking"}</strong>
            </h1>
          </header>
          <div className="drive-in">
            <p className="left">
              <strong>{textKeys.driveInDate || "Indkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(cfBooking.arrivalDate)} ({cfBooking.arrivalTime})
            </p>
          </div>

          <div className="drive-out">
            <p className="left">
              <strong>{textKeys.driveOutDate || "Udkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(cfBooking.departureDate)} ({cfBooking.departureTime})
            </p>
          </div>
          <hr />

          <div className={`parking-info ${cfThirdPartyPromoLabel ? "shows-promo-label" : ""}`}>
            <div className={`parking-product-table__list__col parking-product-table__list__col--title`}>
              <div className="parking-legend__current parking-legend--list">
                <span className={`parking-legend__item parking-legend__item--${oldLegend}`}>{cfCarPark.name}</span>
              </div>
              {windowWidth > 450 ? (
                <h5>{`${cfProduct.name}${cfThirdPartyPromoLabel ? ` - ${cfThirdPartyPromoLabel}` : ""}`}</h5>
              ) : (
                <h5>
                  {cfProduct.name}
                  <br></br>
                  {cfThirdPartyPromoLabel ? cfThirdPartyPromoLabel : ""}
                </h5>
              )}
            </div>
            <p className="right">{props.priceFormatter(changeFromBookingPrice)}</p>
          </div>
          {/* <a className="direction" href="https://www.cph.dk/parkering-transport/parkeringskort">{textKeys.findWayText || "Find vej til"} {cfCarPark.name}</a> */}
        </section>
        <section className="checkout-summary">
          <div className="empty-left">&#8203;</div>
          <div className="button-sector">
            <div className="current-payment">
              <p>{textKeys.subtotalText || "Subtotal"}</p>
              <p>{props.priceFormatter(bookingResultPrice)}</p>
            </div>
            <div className="previous-payment">
              <p>{textKeys.previousPayment || "Tidligere Betalt"}</p>
              <p>{props.priceFormatter(changeFromBookingPrice)}</p>
            </div>
            <div className="differential-payment">
              {/* if payment is 0 */}
              {bookingResultPrice - changeFromBookingPrice === 0 ? (
                <Fragment>
                  <div className="emphasized">{textKeys.totalSamePrice}</div>
                  <div className="emphasized">{props.priceFormatter(bookingResultPrice - changeFromBookingPrice)}</div>
                </Fragment>
              ) : (
                <Fragment>
                  {/* if payment < 0 */}
                  <div className="emphasized">
                    {bookingResultPrice - changeFromBookingPrice > 0 ? textKeys.totalAdditivePrice : textKeys.totalNegativePrice}
                  </div>
                  {/* if payment > 0 */}
                  <div className="emphasized">{props.priceFormatter(bookingResultPrice - changeFromBookingPrice)}</div>
                </Fragment>
              )}
            </div>
            {bookingResultPrice - changeFromBookingPrice === 0 ? (
              <div className="refund-info-text">
                <p>{textKeys.noAdditionalPayment || "Når du klikker gennemfør, ændres din booking & du modtager en ny ordrebekræftelse"}</p>
              </div>
            ) : (
              <Fragment>
                {bookingResultPrice - changeFromBookingPrice < 0 ? (
                  <div className="refund-info-text">
                    <p>{textKeys.refundMessage || "Penge refunderes tilbage til dit betalingskort indenfor 5 hverdage"}</p>
                  </div>
                ) : (
                  <div className="refund-info-text">
                    <p>{textKeys.additionalPayment || "Betalingen består af en ekstra-betaling minus din tidligere betaling"}</p>
                  </div>
                )}
              </Fragment>
            )}
            {/* removed due to https://alphasolutionsdk.atlassian.net/browse/PAR-3827 - if fix is ever requested, re-apply code & fix logic.
              {props.emailUpgradeGuid ? (
                ""
              ) : bookingHasPromotionDiscount ? (
                <div className="booking-discount-container">
                  <div className="booking-discount">
                    <p className="booking-discount-text">
                      {promotionDiscountText.formatUnicorn({ price: -props.priceFormatter(bookingPromotionDiscountValue, true) })}
                    </p>
                  </div>
                </div>
              ) : hasActiveMembershipPrice ? (
                <div className="booking-discount-container">
                  <div className="booking-discount">
                    <p className="booking-discount-text">
                      {membershipDiscountText.formatUnicorn({ price: props.priceFormatter(membershipBookingPriceDifference, true) })}
                    </p>
                  </div>
                </div>
              ) : null}
              */}
          </div>
        </section>
      </section>
    </div>
  )
}
